import React from 'react';
import PropTypes from 'prop-types';
import Select from 'common/StyledSelect';
import { find } from 'lodash';
import css from 'profile/ProfileDropdown.scss';
import { minAppointmentTime } from 'utils/time';

// Staff can limit student scheduling by setting a minimum duration for any office hour appointment.
// Renders a dropdown with the pre-set options they can choose from that ranges between 15 mins to 8 hours.
const MinimumAppointmentDuration = (props) => {
    return <Select id={props.id}
                   ariaLabel={props.ariaLabel}
                   className={css['dropdown']}
                   onChange={minutes => props.onChange(minutes.value)}
                   options={minAppointmentTime}
                   value={find(minAppointmentTime, ['value', props.value])} />
};

MinimumAppointmentDuration.propTypes = {
    id: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired
};

export default MinimumAppointmentDuration;
